import { Pipe, PipeTransform } from "@angular/core";
import { StudentRatingSystemFormService } from "src/app/modules/teacher/components/student-rating-system-filter-form/services/student-rating-system-form.service";
import { StudentStatElement } from "src/app/shared/interfaces/student";

@Pipe({
  name: "studentExercisePercentage",
})
export class StudentExercisePercentagePipe implements PipeTransform {
  constructor(
    private readonly ratingSystemService: StudentRatingSystemFormService,
  ) {}

  transform(statistic: StudentStatElement): number {
    return this.ratingSystemService.calculateTotalPercentage(
      this.ratingSystemService.calculateTotalPoints(statistic),
      this.ratingSystemService.calculateMaxPoints(statistic),
    );
  }
}
